import { Link } from 'react-router-dom';
import DataStore from 'flux/stores/DataStore.js'
import PropTypes from 'prop-types'
import Waypoint from 'react-waypoint';

class Header extends React.Component {
  constructor() {
    super()
    const languages = DataStore.getAllLanguages();
    let lang = DataStore.getAll().lang
    const path = window.location.pathname.split('/')

    if (languages.includes(path[1])) {
      lang = path[1]
    }

    const allPages = DataStore.getAllPages(lang);

    let sorted = _.sortBy(allPages, [function (page) { return page.menu_order; }]);
    sorted = sorted.filter(function (obj) {
      return obj.template !== 'startsida.php' && obj.template !== 'pilgrim.php';
    });

    const index = Math.floor(sorted.length / 2)

    this.state = {
      showMenu: false,
      allPages: sorted,
      languages: languages,
      lang: lang,
      leftPages: sorted.slice(0, index),
      rightPages: sorted.slice(index),
      active: path[path.length - 1],
      style: 'normal',
      logo: 'normal',
    }
    // console.log(window.prerenderReady);
    window.prerenderReady = true;
    // console.log(window.prerenderReady);

  }

  toggleMenu() {
    this.setState({
      showMenu: !this.state.showMenu,
    })
  }

  _handleMenuClick (menuItem) {
    this.setState({ active: menuItem, showMenu: false });
  }

  _setLang(lang) {
    this.setState({ active: undefined, showMenu: false, lang: lang })

    const allPages = DataStore.getAllPages(lang);

    let sorted = _.sortBy(allPages, [function (page) { return page.menu_order; }]);
    sorted = sorted.filter(function (obj) {
      return obj.template !== 'startsida.php';
    });

    const index = Math.floor(sorted.length / 2)

    this.setState({
      allPages: sorted,
      leftPages: sorted.slice(0, index),
      rightPages: sorted.slice(index),
    })
  }

  _setMessage (msg) {
    this.setState({
      style: msg
    })
  }
  _setLogo (msg) {
    this.setState({
      style: msg
    })
  }


  componentWillMount() {
    this.unlisten = this.context.router.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }
  componentWillUnmount() {
      this.unlisten();
  }

  render() {
    const homeLink = this.state.lang === 'sv' ? `/` : `/${this.state.lang}`
    return (
      <div className="header__c">
        <header id="header" className={`header header--${this.state.active}  ${this.context.router.route.location.pathname === homeLink ? ' header--mini' : 'header--'+this.state.style}`}>
          {this.state.showMenu && <Menu pages={this.state.allPages} languages={this.state.languages} parent={this} />}

          <div className="header__container">
            <nav className="header__menu">
              <div className="header__menu__wrap header__menu__wrap--left">
                <div className="header__menu__item header__menu__item--lang">
                  {
                    this.state.languages.map((lang) => {
                      if (lang === this.state.lang) {
                        return
                      }
                      return (
                        <Link
                          key={lang}
                          className={`lang__btn lang__btn--${lang}`}
                          to={lang === 'sv' ? `/` : `/${lang}`}
                          onClick={this._setLang.bind(this, lang)}
                        >{lang}</Link>
                      )
                    })
                  }
                </div>
                {
                  this.state.leftPages.map((page, i) => {
                    const to = this.state.lang === 'sv' ? `/${page.slug}` : `/${this.state.lang}/${page.slug}`
                    return (
                      <div key={page.id} className={'header__menu__item' + (page.template === 'contact.php' ? ' header__menu__item--book' : '')}>
                        <Link
                          key={page.id}
                          to={ to }
                          className={this.context.router.route.location.pathname === to ? 'active' : ''}
                          onClick={this._handleMenuClick.bind(this, page.slug)}
                        >
                          { page.title.rendered.replace('&#038;', '&') }
                        </Link>
                      </div>
                    )
                  })
                }
              </div>
              
              <div className={`header__menu__wrap header__menu__wrap--logo ${this.context.router.route.location.pathname === homeLink ? 'header__home__logo' : ''}`} key="home">
                <div className="header__title__link">
                <Link
                  to={ homeLink }
                  onClick={this._handleMenuClick.bind(this, 'home')}
                >
                  <h1 className="header__title">
                    Anderssons Gästhem & Gårdsbageri 
                  </h1>
                  <div className="header__tagline"></div> 
                </Link>
                </div>
              </div>

              <div className="header__menu__wrap header__menu__wrap--right">
                {
                  this.state.rightPages.map((page, i) => {
                    const to = this.state.lang === 'sv' ? `/${page.slug}` : `/${this.state.lang}/${page.slug}`
                    return (
                      <div key={page.id} className={'header__menu__item' + (page.template === 'contact.php' ? ' header__menu__item--book' : '')}>
                        <Link
                          key={page.id}
                          to={ to }
                          className={this.context.router.route.location.pathname === to ? 'active' : ''}
                          onClick={this._handleMenuClick.bind(this, page.slug)}
                        >
                          { page.title.rendered.replace('&#038;', '&') }
                        </Link>
                      </div>
                    )
                  })
                }
              </div>
            </nav>

            {/* <button className={'header__toggle ' + (this.state.showMenu ? ' header__toggle--active' : '')} onClick={this.toggleMenu.bind(this)}>
              <i></i>
              <i></i>
              <i></i>
            </button> */}

          </div>
        </header>
        { this.context.router.route.location.pathname === homeLink && 
          <div className={`header__home__logo__1 header__home__logo__1--${this.state.style} ${this.state.showMenu ? ' header__home__logo__1--mini' : ''}` }>
            <Waypoint
              onEnter={this._setLogo.bind(this, 'normal')}
              onLeave={this._setLogo.bind(this, 'mini')}
            />
            <div className="header__home__logo__2"></div>
          </div>
        }
        
        <Waypoint
            onEnter={this._setMessage.bind(this, 'normal')}
            onLeave={this._setMessage.bind(this, 'mini')}
          />
      </div>
    );
  }
}

const Menu = (data) => {
  return (
    <ul className="mobile__menu">
      {data.pages.map((page) => {
        if (page.slug != 'startsida') {
          const to = data.parent.state.lang === 'sv' ? `/${page.slug}` : `/${data.parent.state.lang}/${page.slug}`
          return (
            <li key={page.id} className="mobile__menu__item">
              <Link
                className={data.parent.context.router.route.location.pathname === to ? 'active' : ''}
                key={page.id}
                to={data.parent.state.lang === 'sv' ? `/${page.slug}` : `/${data.parent.state.lang}/${page.slug}`}
                onClick={() => data.parent.state.showMenu = false}
              >
                  { page.title.rendered.replace('&#038;', '&') }

              </Link>
            </li>
          )
        }
      })}
      <li className="mobile__menu__item mobile__menu__item--lang">
        {data.languages.map((lang) => {
          return (
            <Link
              key={lang}
              className={`lang__btn lang__btn--${lang}`}
              to={lang === 'sv' ? `/` : `/${lang}`}
              onClick={data.parent._setLang.bind(data.parent, lang)}
            >{lang}</Link>
          )
        })}
      </li>
    </ul>
  )
}

Header.contextTypes = {
  router: PropTypes.object
}

export default Header;


// WEBPACK FOOTER //
// ./src/scripts/components/Header.js